import React from "react";

type Props = {
    children?: React.ReactNode;
};

function AuthFlowTitle({ children }: Props) {
    return <h1 className="text-[32px] font-semibold leading-9">{children}</h1>;
}

export default AuthFlowTitle;
